import { useMatches } from 'react-router-dom';

export const useBasePathname = () => {
  const [containerMatch, layoutMatch, pageMatch] = useMatches();
  const { pathname } = pageMatch ?? layoutMatch ?? containerMatch ?? {};
  const staticPathname = `/${pathname.split('/')[1]}`;

  return staticPathname;
};
